import { Box, Text } from '@chakra-ui/react';

const GeneralInfo = () => {
  return (
    <Box>
      <Box mb={12}>
        <Text fontSize="md" fontWeight={600}>
          Overview
        </Text>
        <Text fontSize="xs">Timeero connects directly with Paycor.</Text>
      </Box>
      <Box>
        <Text fontSize="md" fontWeight={600}>
          What does this integration do?
        </Text>
        <Text fontSize="xs">With Timeero you can export employees, earnings and departments into Paycor.</Text>
      </Box>
    </Box>
  );
};
export default GeneralInfo;
